export default __webpack_public_path__ + "media/images/mailer/icon_add-9f9375d625913db85100af3e0633a67c.png";